/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Whatsapp_Linked_SuccessInputs */

const he_account_delivery_whatsapp_linked_success = /** @type {(inputs: Account_Delivery_Whatsapp_Linked_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ווטסאפ חובר בהצלחה`)
};

const en_account_delivery_whatsapp_linked_success = /** @type {(inputs: Account_Delivery_Whatsapp_Linked_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp linked successfully`)
};

/**
* | output |
* | --- |
* | "WhatsApp linked successfully" |
*
* @param {Account_Delivery_Whatsapp_Linked_SuccessInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_whatsapp_linked_success = /** @type {((inputs?: Account_Delivery_Whatsapp_Linked_SuccessInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Whatsapp_Linked_SuccessInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_whatsapp_linked_success(inputs)
	return en_account_delivery_whatsapp_linked_success(inputs)
});